import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormatAddressPipe } from "./Directives/formatAddress";
import { NgbModule, NgbDateAdapter, NgbDateParserFormatter, NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { MomentModule } from 'ngx-moment';
import { ECINgbDateParserFormatter, NgbDateStringAdapter } from './Directives/DateParser';
import { ArraySortPipe } from "./Directives/sortPipe";
import { ServiceModule } from './service.module';
import { FileUploadModule } from 'ng2-file-upload';
import { MapToIterable } from './Directives/keyValueFilter';
import { CallbackPipe } from './Directives/filterPipe';
import { SortService } from './Services/SortableStuff/sort.service';
import { SortableTableDirective } from './Services/SortableStuff/sortable-table.directive';
import { SortableColumnComponent } from './Services/SortableStuff/sortable-column.component';
import { CommonModule } from '@angular/common';
import { AuthGuardModule } from './auth.module';
import { NouisliderModule } from 'ng2-nouislider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgbTimeStringAdapter } from './Directives/TimeParser';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FileSaverModule } from 'ngx-filesaver';
import { RouterModule } from '@angular/router';
import { RatingComponent } from './Components/3rdParty/Rating/ratingcomponent';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { from } from 'rxjs';
import { DateSearchPartialComponent } from './Components/Partials/DateSearchPartialComponent';
import { SafeHtmlPipe } from './Directives/safeHtmlPipe';
import { SiteSearchComponent } from './Components/Partials/SiteSearchComponent';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PersonDateSearchComponent } from './Components/Partials/PersonDateSearchComponent';
import { CompanySearchComponent } from './Components/Partials/CompanySearchComponent';
import { PageHelpComponent } from './Components/Partials/PageHelpComponent';
import { videoWatcherComponent } from './Directives/videoWatcher';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSliderModule} from '@angular/material/slider';
import {MatInputModule} from '@angular/material/input';
import {MatCommonModule} from '@angular/material/core';
import {MatNativeDateModule} from '@angular/material/core'

@NgModule({
	imports: [
		FileSaverModule,
		NouisliderModule,
		FileUploadModule,
		CommonModule,
		ServiceModule,
		RouterModule,
		AuthGuardModule.forRoot(),
		FormsModule,
		HttpClientModule,
		MomentModule,
		NgbModule,
		ColorPickerModule,
		EditorModule,
		NgxMaterialTimepickerModule,
		NgxExtendedPdfViewerModule,
		DragDropModule,
		MatSliderModule,
		MatFormFieldModule,
		MatSelectModule,
		MatNativeDateModule,
		MatInputModule
	],
	exports: [
		FileSaverModule,
		NouisliderModule,
		FileUploadModule,
		ServiceModule,
		AuthGuardModule,
		FormsModule,
		HttpClientModule,
		FormatAddressPipe,
		SafeHtmlPipe,
		ArraySortPipe,
		MomentModule,
		NgbModule,
		MapToIterable,
		ColorPickerModule,
		CallbackPipe,
		SortableTableDirective,
		SortableColumnComponent,
		RouterModule,
		EditorModule,
		DragDropModule,
		RatingComponent,
		NgxMaterialTimepickerModule,
		DateSearchPartialComponent,
		PersonDateSearchComponent,
		NgxExtendedPdfViewerModule,
		SiteSearchComponent,
		CompanySearchComponent,
		MatSliderModule,
		PageHelpComponent,
		MatFormFieldModule,
		MatSelectModule,
		MatNativeDateModule,
		MatInputModule,
		videoWatcherComponent
	],
	providers: [
	
		SortService,

	],
	declarations: [
		RatingComponent,
		FormatAddressPipe,
		SafeHtmlPipe,
		ArraySortPipe,
		MapToIterable,
		CallbackPipe,
		SortableTableDirective,
		SortableColumnComponent,
		DateSearchPartialComponent,
		PersonDateSearchComponent,
		CompanySearchComponent,
		SiteSearchComponent,
		PageHelpComponent,
		videoWatcherComponent
	],

})
export class LocalCommonModule {
	static forRoot() {
		return {
			ngModule: LocalCommonModule,
			providers: [
				{ provide: NgbDateParserFormatter, useClass: ECINgbDateParserFormatter },
				{ provide: NgbDateAdapter, useClass: NgbDateStringAdapter },
				{ provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter },

			],
		}
	}
}
